import { render } from "./WelcomeView.vue?vue&type=template&id=3ec45c6d&scoped=true"
import script from "./WelcomeView.vue?vue&type=script&lang=js"
export * from "./WelcomeView.vue?vue&type=script&lang=js"

import "./WelcomeView.vue?vue&type=style&index=0&id=3ec45c6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec45c6d"]])

export default __exports__